import { getRanges } from 'pages/private/owner/reports/ClassUsage/components/DateRangePicker/presets';
import { EventType } from 'types';

interface PackageUtilizationSearchFilters {
  period: string;
  startDate: Date | null;
  endDate: Date | null;
  utilizationRateRange: [number, number] | null;
  athleteIds: string[] | null;
  packageIds: string[] | null;
  eventTypes: EventType[];
  groupByAthlete: boolean;
  groupByPackage: boolean;
}

const initialSearchFilters: PackageUtilizationSearchFilters = {
  period: 'last_week',
  startDate: getRanges('last_week')[0],
  endDate: getRanges('last_week')[1],
  utilizationRateRange: null,
  athleteIds: [],
  packageIds: [],
  eventTypes: [],
  groupByAthlete: true,
  groupByPackage: true,
};

export { initialSearchFilters, type PackageUtilizationSearchFilters };
